<section class="product-slider-two">
    <div *ngIf="promotionMessage && displayPromotionMessage">
        <h2 *ngIf="displayPromotionMessage" class="category-title">{{promotionMessage}}</h2>
    </div>
    <ngx-slick-carousel class="product-5 product-m no-arrow" #slickModal="slick-carousel" [config]="productSlideConfig">
        <div ngxSlickItem class="product-box product-wrap" *ngFor="let product of products | slice:0:8">
            <pdp-product-box [company]="company" [product]="product"></pdp-product-box>
        </div>
    </ngx-slick-carousel>
</section>